import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { D1EventRow, useD1EventColumns } from "./columns";
import { FilterD1Events, type FilterD1EventsSchema } from "./filter";

const client = "d1";
const table_name = "d1_events";

export function D1EventsTable() {
  const { t } = useTranslation();
  const columns = useD1EventColumns();

  return (
    <Table<D1EventRow, FilterD1EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterD1Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
